export const REPORTS_HANDLE_MODAL_DOWNLOAD_FILES = "REPORTS_HANDLE_MODAL_DOWNLOAD_FILES";

